<button class="button icon toast-close-btn"></button>